import { House } from '@mui/icons-material';
import { FieldControllerTypes, IFormController } from '../../../components/form_v2/types';

export const insertForeasFields = () => {

  const insertStep1Form: IFormController[] = [
    {
      control: FieldControllerTypes.input,
      label: 'Μοναδικός Κωδικός Φορέα',
      name: 'organisationsUniqueCode',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Aναγνωριστικό Φορέα',
      name: 'orgIdentifierCountryId',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Επωνυμία Φορέα',
      name: 'organisationsName',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Συντομογραφία Φορέα στα Αγγλικά',
      name: 'orgIdentifierEnAbbreviation',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Επωνυμία Φορέα στα Αγγλικά',
      name: 'organisationsEnNameEn',
      required: true,
    },
    {
      control: FieldControllerTypes.input,
      label: 'Συντομογραφία Φορέα',
      name: 'organisationsAbbreviation',
      required: true,
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Παρατηρήσεις Σχόλια Φορέα',
      name: 'orgIdentifierComments',
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Παρατηρήσεις Σχόλια Φορέα στα Αγγλικά',
      name: 'orgIdentifierCommentsEn',
    }
  ];
  const insertStep2Form: IFormController[] = [
    {
      control: FieldControllerTypes.input,
      label: 'Email  Φορέα',
      name: 'organisationsEmail',
      required: true,
    },
    {
      control: FieldControllerTypes.input,
      label: 'Website Φορέα',
      name: 'organisationsWebsite',
      required: true,
    },
    {
      control: FieldControllerTypes.telInput,
      label: 'Τηλέφωνο Φορέα',
      name: 'organisationsTelephone',
      required: true,
    },
    {
      control: FieldControllerTypes.input,
      label: 'Διεύθυνση Φορέα',
      name: 'orgIdentifierFullAddress',
      placeholder: 'Οδός, Αριθμός, Τ.Κ., Πόλη',
      required: true,
    },
    {
      control: FieldControllerTypes.input,
      label: 'Χώρα Φορέα',
      name: 'organisationsCountry',
      required: true,
    }
  ];
    
  const insertStep1 = {
    label: 'Βασικές Πληροφορίες Φορέα',
    content: insertStep1Form,
    icon: <House/>
  };
  const insertStep2 = {
    label: '​Στοιχεία Επικοινωνίας και Διεύθυνσης',
    content: insertStep2Form,
    icon: <House/>
  };
  return [
    {...insertStep1},
    {...insertStep2}
  ];
};
